export const hotRanking = [
  { rank: 1, title: '音乐节抢票系统拥堵事件', source: '演出行业', heat: '9.8万', trend: 'up' },
  { rank: 2, title: '户外综艺录制片段流出', source: '综艺速报', heat: '8.6万', trend: 'up' },
  { rank: 3, title: '演唱会门票实名制升级', source: '娱乐现场', heat: '8.2万', trend: 'flat' },
  { rank: 4, title: '老牌综艺阵容官宣回归', source: '综艺速报', heat: '7.8万', trend: 'new' },
  { rank: 5, title: '头部创作者团队重组', source: '网红动向', heat: '7.3万', trend: 'up' },
  { rank: 6, title: '转会窗口最后一周官宣潮', source: '赛事转会', heat: '6.9万', trend: 'up' },
  { rank: 7, title: '待播剧集中调整排期', source: '影视动态', heat: '6.2万', trend: 'flat' },
  { rank: 8, title: '主播合约模板更新', source: '直播生态', heat: '5.4万', trend: 'down' },
  { rank: 9, title: '竖屏短剧上新创新高', source: '短剧赛道', heat: '4.8万', trend: 'up' },
  { rank: 10, title: '文娱半年报内容成本下降', source: '商务观察', heat: '3.7万', trend: 'flat' },
];

export const hotWords = [
  { word: '抢票系统', weight: 'lg' },
  { word: '阵容官宣', weight: 'lg' },
  { word: '实名制', weight: 'md' },
  { word: '合约模板', weight: 'md' },
  { word: '定档排期', weight: 'md' },
  { word: '短剧赛道', weight: 'lg' },
  { word: '转会窗口', weight: 'sm' },
  { word: '内容合规', weight: 'sm' },
  { word: '团队重组', weight: 'md' },
  { word: '板块补强', weight: 'sm' },
  { word: '降本增效', weight: 'sm' },
  { word: '现场直击', weight: 'md' },
];

export const rankTabs = [
  { id: '24h', label: '24小时' },
  { id: '7d', label: '近7天' },
  { id: 'month', label: '本月' },
];

export const rankTabData = {
  '24h': hotRanking,
  '7d': [
    { rank: 1, title: '音乐节票务补偿方案落地', source: '演出行业', heat: '24.6万', trend: 'up' },
    { rank: 2, title: '短剧单月上新数据公布', source: '短剧赛道', heat: '21.3万', trend: 'up' },
    { rank: 3, title: '多平台同步调整分成条款', source: '直播生态', heat: '19.8万', trend: 'flat' },
    { rank: 4, title: '暑期档影视基地开放', source: '影视动态', heat: '17.2万', trend: 'new' },
    { rank: 5, title: '综艺赛制改革方案曝光', source: '综艺速报', heat: '15.9万', trend: 'up' },
    { rank: 6, title: '行业合规指引征求意见', source: '产业政策', heat: '13.4万', trend: 'flat' },
    { rank: 7, title: '青训球员上调一线名单', source: '赛事转会', heat: '11.8万', trend: 'up' },
    { rank: 8, title: '创作者账号矩阵调整', source: '网红动向', heat: '10.2万', trend: 'down' },
    { rank: 9, title: '代言合作预算重新分配', source: '商务观察', heat: '8.7万', trend: 'flat' },
    { rank: 10, title: '线下活动检票流程升级', source: '娱乐现场', heat: '7.5万', trend: 'up' },
  ],
  month: [
    { rank: 1, title: '内容合规指引草案发布', source: '产业政策', heat: '86.4万', trend: 'new' },
    { rank: 2, title: '演出市场年度数据出炉', source: '演出行业', heat: '78.1万', trend: 'up' },
    { rank: 3, title: '直播合约体系集体调整', source: '直播生态', heat: '69.5万', trend: 'up' },
    { rank: 4, title: '短剧赛道投放大盘变化', source: '短剧赛道', heat: '61.2万', trend: 'flat' },
    { rank: 5, title: '多部待播剧排期重构', source: '影视动态', heat: '55.8万', trend: 'up' },
    { rank: 6, title: '综艺市场回归经典赛道', source: '综艺速报', heat: '49.3万', trend: 'up' },
    { rank: 7, title: '转会窗口整体成交统计', source: '赛事转会', heat: '42.6万', trend: 'flat' },
    { rank: 8, title: '创作者生态结构调整', source: '网红动向', heat: '38.9万', trend: 'down' },
    { rank: 9, title: '文娱公司半年报汇总', source: '商务观察', heat: '33.4万', trend: 'flat' },
    { rank: 10, title: '线下演出规模持续回升', source: '娱乐现场', heat: '29.7万', trend: 'up' },
  ],
};